module.exports = __webpack_public_path__ + "static/media/pole-number-example-1.72b99097.png";